import { EntityType } from '@communities/content-management/domain';

/**
 * Helper function to get display name for entity type
 */
export function getEntityDisplayName(entityType: EntityType): string {
  switch (entityType) {
    case EntityType.COMMUNITY:
      return 'community';
    case EntityType.COMMUNITY_GROUP:
      return 'community group';
    default:
      return 'entity';
  }
}
